import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, watch } from 'vue';
import { useFonts } from '@/composables/fonts';
import FontSelector from '../FontSelector.vue';
import CInput from '@/components/shared/CInput.vue';
import type { CSelectItem } from '@/components/shared/CSelect';
import type { ImagePlaceholderElement, WordCloudConfig } from '@/typings/customilyElements/canvasElements';
import type { CanvasEx } from '@/typings/canvas';
import { ptToPx, pxToPt } from '@/utils/elementsUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'CharacterProperties',
  props: {
    canvas: null,
    imageElement: null,
    editMode: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    canvas: CanvasEx;
    imageElement?: ImagePlaceholderElement;
    editMode?: boolean;
};



const model = reactive({
    font: undefined as CSelectItem<string> | undefined,
    minFontSize: 0,
    maxFontSize: 50,
    maxWords: 100
});

const canvasDpi = computed(() => props.canvas.DPI);

const { getFontFromPath, generateFontName } = useFonts();
watch(
    () => props.imageElement,
    (element) => {
        if (!element || !element.wordCloudConfig) return;

        const config = element.wordCloudConfig;
        model.minFontSize = pxToPt(config.minFontSize || 0, canvasDpi.value);
        model.maxFontSize = pxToPt(config.maxFontSize || 50, canvasDpi.value);
        model.maxWords = config.maxWords || 100;

        const font = getFontFromPath(config.font);
        if (font) {
            model.font = {
                label: generateFontName(font),
                value: config.font
            };
        }
    },
    { immediate: true }
);

const disabled = computed(() => !!props.imageElement?.locked);

const onFontSelected = () => {
    updateWordCloudConfig({ font: model.font?.value });
};

const updateFontSize = (prop: 'minFontSize' | 'maxFontSize', value = 0) => {
    updateWordCloudConfig({ [prop]: ptToPx(value, canvasDpi.value) });
};

const updateWordCloudConfig = (config: Partial<WordCloudConfig>) => {
    const element = props.imageElement;
    if (!element) return;

    const newConfig = { ...element.wordCloudConfig, ...config } as WordCloudConfig;
    element.set('wordCloudConfig', newConfig);
    if (props.editMode) element.setEditedProp('wordCloudConfig');
};

return { __sfc: true,props, model, canvasDpi, getFontFromPath, generateFontName, disabled, onFontSelected, updateFontSize, updateWordCloudConfig, FontSelector, CInput }
}

})